'use client';

import React, { createContext, ReactNode, useContext, useState } from 'react';

type MapFilterContextType = {
  showAreaBoundary: boolean;
  showSudsMarkers: boolean;
  showCsoMarkers: boolean;
  sudsTypeFilter: string[];
  setShowAreaBoundary: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCsoMarkers: React.Dispatch<React.SetStateAction<boolean>>;
  setShowSudsMarkers: React.Dispatch<React.SetStateAction<boolean>>;
  setSudsTypeFilter: React.Dispatch<React.SetStateAction<string[]>>;
};

export const MapFilterContext = createContext<MapFilterContextType | undefined>(undefined);

type MapFilterContextProviderProps = {
  children: ReactNode;
};

export function MapFilterContextProvider({ children }: MapFilterContextProviderProps) {
  const [showAreaBoundary, setShowAreaBoundary] = useState<boolean>(true);
  const [showCsoMarkers, setShowCsoMarkers] = useState(true);
  const [showSudsMarkers, setShowSudsMarkers] = useState(true);
  const [sudsTypeFilter, setSudsTypeFilter] = useState<string[]>([]);

  return (
    <MapFilterContext.Provider
      value={{
        showAreaBoundary,
        showSudsMarkers,
        showCsoMarkers,
        sudsTypeFilter,
        setShowAreaBoundary,
        setShowCsoMarkers,
        setShowSudsMarkers,
        setSudsTypeFilter,
      }}
    >
      {children}
    </MapFilterContext.Provider>
  );
}

export const useMapFilterContext = () => {
  const context = useContext(MapFilterContext);
  if (context === undefined) {
    throw new Error('useMapFilterContext must be used within a MapFilterContextProvider');
  }
  return context;
};
